// Module
var code = "<div ref=\"imageContainer\" class=\"flex flex-column justify-content-center align-center\"></div>\n<div ref=\"borderRightContainer\" class=\"flex flex-column justify-content-center align-center\"></div>\n<div ref=\"loginContainer\" class=\"flex flex-column justify-content-center align-center\"></div>";
// Exports
module.exports = code;